export const dialogMixin = {
    methods: {
        successAlert() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure you want to delete this?',
                accept: this.acceptAlert
              })
        },
        
        
    }
};